import { render } from "./AuditLogs.vue?vue&type=template&id=02d99131&ts=true"
import script from "./AuditLogs.vue?vue&type=script&lang=ts"
export * from "./AuditLogs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__